<script setup lang="ts">
import { useRenderStore } from "@/builder/stores/renderStore";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { inject, Ref, computed, ref } from "vue";
import { PageDesign } from "../page/PageInterface";
import { FieldStyle } from "@/builder/enums";

const renderStore = useRenderStore();
defineProps(["component"]);

const pageDesign = inject("pageDesign") as Ref<PageDesign>;
const fieldStyle = computed(() => {
    return pageDesign.value.fieldStyle;
});

const emailInput = ref();

const sanitizeEmail = (e: any) => {
    let email = e.target.value as string | null;
    if (email) {
        //trim white space from email
        email = email.trim();
        renderStore.donor.email = email;
    }
}

</script>

<template>
    <div class="form-row email-container">
        <ValidatedInput ref="emailInput" :id="component.id" :value="renderStore.donor.email"
            :label="component.customData.label" class="rd-w-full"
            :class="{ 'form-compact-full': fieldStyle == FieldStyle.Compact }" accessibleLabel="Email"
            name="Donor.Email" :isRequired="true" :isEmail="true">
            <template #input="inputProps">
                <input type="text" :id="component.id + '_Donor.Email'" :placeholder="component.customData.placeholder"
                    aria-required="true" :aria-describedby="inputProps.describedBy" :aria-invalid="inputProps.isInvalid"
                    v-model="renderStore.donor.email" @change="sanitizeEmail" autocomplete="email" />
            </template>
        </ValidatedInput>
    </div>
</template>
